import { Drawer, Image, Layout, Radio } from 'antd';
import React, { useState } from 'react';
import { Images } from '../../../../controller/Images';
import { CheckCircleFilled, CloseOutlined } from '@ant-design/icons';
import { getAdminDetail } from '../../../../controller/localStroageHandler';
const { Content, Header, Sider } = Layout;
const PreviewSidebar = ({
  drawerVisible,
  toggleDrawer,
  menuItemValue,
  menuItem,
}) => {
  let data = getAdminDetail()
  const SidebarMenuItem = () => {
    return (
      <div className='d-flex flex-column gap-1 mt-5'>
        {menuItem?.map((val, index) => (
          <div
            key={index}
            className={`w-100 rounded-3 p-2 text-black text-capitalize ${menuItemValue === index && 'sidebar-item-background-color'
              } ${val?.radio ? 'fw-bolder' : 'fw-semibold'}`}
          >
            <Radio
              className={`custom-radio`}
              checked={val?.complete == 100 ? true : false}
            >
              {val.name}
            </Radio>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <Sider
        className='bg-white border-end p-4 d-flex flex-column d-lg-block d-sm-none responsive-sidebar '
      // breakpoint='md'
      // collapsedWidth={0}
      // collapsed={sidebar}
      // onCollapse={setSidebar}
      >
        <div className='w-100 d-flex justify-content-center align-items-center'>
          <Image
            src={data?.organization_id?.logo || Images.logo}
            alt=''
            className='logo'
            width={'auto'}
            height={50}
            preview={false}
          />
        </div>
        <SidebarMenuItem />
      </Sider>
      <Drawer
        title=''
        placement='left'
        closable={false}
        onClose={toggleDrawer}
        visible={drawerVisible}
      >
        <CloseOutlined
          className='d-flex align-items-end justify-content-end'
          onClick={() => toggleDrawer()}
        />
        <div className='w-100 d-flex justify-content-center align-items-center'>
          <Image
            src={data?.organization_id?.logo || Images.logo}
            alt=''
            className='logo'
            width={'auto'}
            height={50}
            preview={false}
          />
        </div>
        <SidebarMenuItem />
      </Drawer>
    </>
  );
};

export default PreviewSidebar;
